const SYS_ADMIN = "SYS_ADMIN";
const ADMIN = "ADMIN";
const BSA = "BSA";
const CHIEF_SUPERVISOR = "CHIEF_SUPERVISOR";
const SUPERVISOR = "SUPERVISOR";
const ANALYST = "ANALYST";

export const rolesObject = {
	SYS_ADMIN,
	ADMIN,
	BSA,
	CHIEF_SUPERVISOR,
	SUPERVISOR,
	ANALYST,
};

// SYS_ADMIN users are cross-tenant; the API defaults tenantId to this value
export const SYS_ADMIN_TENANT_ID = "0";
